/**
 * メンションのアバター画像の読み込み失敗時の処理。
 *
 * img の onerror 属性は CSP（nonce 付き script-src）でインラインイベントハンドラーとして実行がブロックされるため使えない。
 * error イベントは bubble しないので、document のキャプチャフェーズで拾う。
 * 対象は js-mention-avatar クラスの img のみ。
 *
 * 1. data-fallback（コミュニティの既定アバター）があれば一度だけ差し替える
 * 2. fallback が無い、または差し替え後も失敗した場合は非表示にする
 */
const AVATAR_CLASS = 'js-mention-avatar';

export function handleMentionAvatarError(event) {
  const img = event.target;
  if (!(img instanceof HTMLImageElement) || !img.classList.contains(AVATAR_CLASS)) return;

  const fallback = img.dataset.fallback;
  if (fallback && !img.dataset.fallbackTried) {
    img.dataset.fallbackTried = 'true';
    img.src = fallback;
    return;
  }

  img.style.visibility = 'hidden';
}

let isBound = false;

export function bindMentionAvatarErrorHandler() {
  if (isBound) return;

  isBound = true;
  document.addEventListener('error', handleMentionAvatarError, true);
}
